/* eslint-disable react-hooks/exhaustive-deps */
import { ClearableSearchField } from "components/SearchField/SearchField";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import {
  deleteParameterSettingsRecords,
  fetchParameterSettings,
} from "utils/superAdminApi";

let searchParameter = "";
let parameterStatus = "Active";

function ParameterSetting() {
  const [customerReload, setCustomerReload] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    parameterStatus: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: [
      "parameterStatus",
      "parameterValue",
      "parameterLength",
      "parameterType",
      "parameterCode",
      "parameterName",
    ],
  });

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchParameterSettingsData();
    })();
  }, [values.parameterStatus, values.sortingType, perPage, dispatch]);

  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchParameterSettingsData();
    }
  }, [values.filterValues]);

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = [];
    values._id.push(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteSettings();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchParameterSettingsData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const deleteSettings = async () => {
    await deleteParameterSettingsRecords(
      values,
      (data) => {
        fetchParameterSettingsData();
        setTitle("");
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  async function getRight() {
    let right = await getScreenRight("Parameter Settings");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  useEffect(() => {
    parameterStatus = values.parameterStatus;
    changeCustomerReload();
  }, [values.parameterStatus]);

  const fetchParameterSettingsData = async () => {
    values.searchParameter = searchParameter;
    values.parameterStatus = parameterStatus;
    await fetchParameterSettings(
      values,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  let columns = [
    {
      name: "Parameter Name",
      selector: (row) => row.parameterName,
      sortable: true,
      sortField: "parameterName",
      left: true,
    },
    {
      name: "Parameter Code",
      selector: (row) => row.parameterCode,
      sortable: true,
      sortField: "parameterCode",
      center: true,
    },
    {
      name: "Parameter Type",
      selector: (row) => row.parameterType,
      sortable: true,
      sortField: "parameterType",
      center: true,
    },
    {
      name: "Parameter Length",
      selector: (row) => row.parameterLength,
      sortable: true,
      sortField: "parameterLength",
      center: true,
    },
    {
      name: "Parameter Value",
      selector: (row) => row.parameterValue,
      sortable: true,
      sortField: "parameterValue",
      center: true,
    },

    {
      // name: "Status",
      name: <p style={{ paddingLeft: "12px" }}>Status</p>,
      selector: (row) => row.parameterStatus,
      sortable: true,
      sortField: "parameterStatus",
      center: true,
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              <Link to={`/parametersetting/edit/${row._id}`}>
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Parameter Settings" />
          <Grid
            container
            display={"flex"}
            justifyContent="end"
            mt={2.2}
            gap={2}
          >
            <Grid lg={2.5} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={values.parameterStatus}
                  onChange={(e) =>
                    setValues({ ...values, parameterStatus: e.target.value })
                  }
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchParameterSettingsData();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.5rem  0.5rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={fetchParameterSettingsData}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: "16px" }}>
              <Link to={"/parametersetting/addNew"}>
                <MDButton
                  variant="contained"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color={disableColor ? "secondary" : "success"}
                  style={{ height: "44.11px", width: "99px" }}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </Card>
      </div>
      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
    </DashboardLayout>
  );
}

export default ParameterSetting;
